import { render } from "./TopNavBar.vue?vue&type=template&id=2605c874&scoped=true"
import script from "./TopNavBar.vue?vue&type=script&lang=js"
export * from "./TopNavBar.vue?vue&type=script&lang=js"

import "../styles/TopNavBar.scss?vue&type=style&index=0&id=2605c874&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/biology-microscopy/biology-microscopy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2605c874"]])

export default __exports__